"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AngusMobDetailSchema = exports.CalveTransactionSchema = exports.RmvCalveInfoSchema = exports.AddCalveInfoSchema = void 0;
const zod_1 = require("zod");
exports.AddCalveInfoSchema = zod_1.z.object({
    nlis_id: zod_1.z.string(),
    rfid: zod_1.z.string(),
    sex: zod_1.z.string(),
    visual_tag: zod_1.z.string()
});
exports.RmvCalveInfoSchema = exports.AddCalveInfoSchema.omit({ nlis_id: true });
exports.CalveTransactionSchema = zod_1.z.object({
    add: zod_1.z.array(exports.AddCalveInfoSchema),
    remove: zod_1.z.array(exports.RmvCalveInfoSchema)
});
// AngusMob
exports.AngusMobDetailSchema = zod_1.z.object({
    breederPicAddress: zod_1.z.string(),
    angusAuthToken: zod_1.z.string().optional(),
    mob_name: zod_1.z.string(),
    birth_year: zod_1.z.number(),
    birth_start: zod_1.z.string(),
    birth_end: zod_1.z.string(),
    sire_id: zod_1.z.string(),
    sire_group_name: zod_1.z.string(),
    sire_group_id: zod_1.z.string(),
    breeder_pic_number: zod_1.z.string(),
    mob_sex: zod_1.z.string(),
    pic: zod_1.z.string(),
    acct_id: zod_1.z.string(),
    calves: exports.CalveTransactionSchema,
    recordedIn: zod_1.z.string()
});
